function FrasePanel() {
  const Frases = [
    'Nuestro peor enemigo es el aburrimiento',
    'En estos momentos estas creando tu vida',
    'El trabajo hecho a gusto no cansa jamás',
    'Quien no quita gotera, hace casa entera',
    'En largos caminos se conocen los amigos',
    'Al hombre osado la fortuna le da la mano',
     'Una gran fortuna es una gran servidumbre',
    'El conocimiento no vale si no se comparte',
    'A veces para huir se necesita mucho valor',
    'Los sentidos no engañan, engaña el juicio',
    'Ningun hombre ha sido sabio de casualidad',
    'El vago trabaja más por evitar el trabajo',
    'La amistad no se agradece, se corresponde',
    'El que teme padecer padece ya lo que teme',
    'Aprender es descubrir que algo es posible',
    'No hay maestro que no pueda ser discípulo',
    'Tener muchos amigos es no tener ningún amigo',
    'La manera de dar vale más que lo que se da',
    'Se aprende más de quien no nos da la razón',
    'Si amas lo que haces, nunca será un trabajo',
    'La única manera de poseer un amigo es serlo',
    'El fracaso no existe, solo existen resultados',
    'Envejecer es obligatorio, crecer es opcional',
    'Ningún hombre es feliz a menos que crea serlo',
    'El trabajo y el comer, su medida han de tener',
    'Los oídos no sirven de nada a un cerebro ciego',
    'Los juicios de los demas no crean mi realidad',
    'No canto para ser feliz, soy feliz porque canto',
    'En este mundo al revés, no hay amor sin interés',
    'El hombre nunca es demasiado viejo para aprender',
    'La amistad termina donde la desconfianza empieza',
    'En la juventud aprendemos, en la vejez entendemos',
    'Haz lo que puedas, con lo que tengas, donde estés',
    'Podré perder la vida pero la vida no me la pierdo',
    'El trabajar cuesta, pero cuesta más el no trabajar',
    'Para amigo, cualquiera, para enemigo, quien quiera',
    'Lo que de raíz se aprende nunca del todo se olvida',
    'Algún dinero evita preocupaciones, mucho, las atrae',
    'No tiene ningún amigo el que tiene demasiados amigos',
    'Ninguno hay que no pueda ser maestro de otro en algo',
    'Trabaja para vivir, pero no vivas sólo para trabajar',
    'El dinero es un buen sirviente, pero un pésimo maestro',
    'El dinero siempre está ahí, sólo cambian los bolsillos',
    'No hay día más perdido que aquel en que no hemos reido',
    'Quien se atreve a enseñar, nunca debe dejar de aprender',
    'A todos les encanta trabajar, excepto a los que trabajan',
    'Nos interesan los demás cuando se interesan por nosotros',
    'La libertad no es la licencia para realizar cualquier cosa',
    'La popularidad es como la juventud, una vez ida, no vuelve',
    'El victorioso tiene muchos amigos, el vencido, buenos amigos',
    'La inteligencia es útil en todo, pero no suficiente para todo',
    'Hay que estudiar mucho para llegar a saber un poco',
    'Hoy es el mañana acerca del cual te preocupabas ayer',
  ];


  // Obtiene un Array en Json de localStorage y lo reconvierte a array
  let panelesLocalStorage = JSON.parse(localStorage.getItem('panelesResueltos'));
  let newPaneles;

  let random = Math.floor(Math.random() * (Frases.length - 0) + 0);

  if (panelesLocalStorage !== null) {

    // Si todos los paneles se han resuelto, se vacía el array
    // de paneles resueltos para que empiece otra vez de nuevo
    if (panelesLocalStorage.length === Frases.length) {
      panelesLocalStorage = [];
    }

    // Mientras el array de los paneles resueltos incluya el número random
    // del nuevo panel, se genera un nuevo número hasta que no esté en el array
    while (panelesLocalStorage.includes(random)) {
      random = Math.floor(Math.random() * (Frases.length - 0) + 0);
    }

    // Se incluye el número número entre los paneles resueltos
    panelesLocalStorage.push(random);
    newPaneles = panelesLocalStorage;

  } else {

    newPaneles = [random];

  }

  const frase = Frases[random].toUpperCase();

  return [frase, newPaneles];

}

export default FrasePanel;
